import { pagesConfig } from '../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../shared/simple-breadcrumbs-page';
import { ModuleList } from '../../shared/analytics/module-list';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import ClickableCard from '../../shared/clickable-card';
import { Outlet, useNavigate } from 'react-router-dom';
import { useRouteMatch } from '../../shared/useRouteMatch';

export default function InsightsCloudInsightsPage() {
  const navigate = useNavigate();
  const BREADCRUMBS = [
    { label: ModuleList.modules.insights.name },
    { label: pagesConfig.insightsCloudInsights.name },
  ];
  const cloudInsightsLink = `${pagesConfig.insights.link}/${pagesConfig.insightsCloudInsights.link}`;
  const isSubPageClicked = useRouteMatch([
    `/${cloudInsightsLink}/${pagesConfig.insightsAssetDiscovery.link}`,
    `/${cloudInsightsLink}/${pagesConfig.insightsRecommendations.link}`,
    `/${cloudInsightsLink}/${pagesConfig.insightsDailyTrends.link}`,
    `/${cloudInsightsLink}/${pagesConfig.insightsFinOps.link}`,
    `/${cloudInsightsLink}/${pagesConfig.insightsAgentCost.link}`,
    `/${cloudInsightsLink}/${pagesConfig.insightsAgentOps.link}`,
    `/${cloudInsightsLink}/${pagesConfig.insightsUserUsage.link}`,
  ]);

  const insightsCards = [
    pagesConfig.insightsAssetDiscovery,
    pagesConfig.insightsRecommendations,
    pagesConfig.insightsDailyTrends,
    pagesConfig.insightsFinOps,
    pagesConfig.insightsAgentCost,
    pagesConfig.insightsAgentOps,
    pagesConfig.insightsUserUsage,
  ].map(({ name, link }) => ({
    title: name,
    path: `/${cloudInsightsLink}/${link}`,
  }));

  if (isSubPageClicked) return <Outlet />;

  return (
    <SimpleBreadcrumbsPage breadcrumbs={BREADCRUMBS} shouldAllowHeightToScroll>
      <Box p={1}>
        <Typography variant="body1">
          The primary goal of the Promevo Cloud Insights service is to provide
          your company an understanding of the health of your Google Cloud
          environment.
        </Typography>
        <Stack
          direction="row"
          sx={{
            mt: 3,
            gap: 3,
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          {insightsCards.map(({ title, path }) => (
            <ClickableCard
              key={path}
              title={title}
              onClick={() => navigate(path)}
            />
          ))}
        </Stack>
      </Box>
    </SimpleBreadcrumbsPage>
  );
}
